import { render, staticRenderFns } from "./cities.vue?vue&type=template&id=2a9cb33c&scoped=true&"
import script from "./cities.vue?vue&type=script&lang=ts&"
export * from "./cities.vue?vue&type=script&lang=ts&"
import style1 from "./cities.vue?vue&type=style&index=1&id=2a9cb33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9cb33c",
  null
  
)

export default component.exports